import FieldsetHybrid from "./FieldsetHybrid";
import { FieldsetLegend, FieldsetHelperText } from "./FieldsetParts";

/**
 * Fieldset Component
 *
 * Thin assembly over the hybrid implementation: FieldsetHybrid routes to the
 * styled-components path when styled-system props are passed and to the Tailwind
 * path otherwise. The public Fieldset.Legend / Fieldset.HelperText statics remain
 * Text-based (see FieldsetParts) so they keep accepting styled-system props.
 */
const Fieldset = Object.assign(FieldsetHybrid, {
  Legend: FieldsetLegend,
  HelperText: FieldsetHelperText,
});

export default Fieldset;
